<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: '',
    required: false
  }
})
</script>

<template>
  <div class="sectiontitle">
    <div class="inner">
      <h1 class="title">
        {{ title }}
      </h1>
    </div>
    <p
      v-if="text"
      class="text"
    >
      {{ text }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.sectiontitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  .inner {
    gap: 6px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    flex: 1;
    gap: 5px;
    color: #101010;
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
    overflow-x: unset;
    white-space: wrap;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .note {
    color: #ccc;
    font-size: 12px;
    line-height: 12px;
  }
  .button {
    display: flex;
    justify-content: flex-end;
  }
  .text {
    color: #101010;
    font-size: 14px;
    line-height: 14px;
    text-align: right;
  }
  .search {
    position: relative;
    .input {
      max-width: 130px;
      padding: 5px 35px 5px 10px;
      background-color: #fff;
      border: solid 1px #c0c0c0;
      border-radius: 66px;
      font-size: 15px;
      line-height: 1.5em;
    }
    .submit {
      position: absolute;
      top: -3px;
      right: 10px;
    }
  }
}
main {
  @media screen and (min-width: 830px) {
    .sectiontitle {
      flex-direction: row;
      gap: 0;
      align-items: center;
      justify-content: space-between;
      .title {
        flex-direction: row;
        font-size: 22px;
        line-height: 22px;
        white-space: wrap;
        overflow-x: unset;
        &::after {
          display: none;
        }
      }
      .text {
        font-weight: 600;
      }
    }
  }
}
</style>
